import React from "react";
import { Switch } from 'antd'

export default function CheckboxSwitchery({ checked, disabled, onChange }) {

  return (
    <Switch checked={checked}
      checkedChildren="Yes"
      unCheckedChildren="No"
      onChange={onChange}
      disabled={disabled}
      style={checked === true ? {
        fontSize: "18px",
        // backgroundColor: "#04a596",
        fontWeight: "bold",
      } : {
          fontSize: "18px",
          // backgroundColor: "#a21b1b",
          fontWeight: "bold",
        }
      }
    />
  );
};
